export const STAGE = process.env.STAGE || 'prod'

export const API_URL = process.env.WEB_API_URL || `${window.origin}/web-api`
